import React from 'react';
import { useDispatch, useSelector } from "react-redux";
import { setWorkoutPaymentFormAction } from "../../redux/rootReducer";
import Payment from "../Payment/Payment";
import { WORKOUT_PAYMENT_FORM_INITIAL } from "../../redux/initialStateConstant";
import { workoutPaymentSagaAction } from "../../redux/sagaActions";
import Checkbox from "../Checkbox/Checkbox";

const WorkoutPaymentForm = () => {
    const dispatch = useDispatch();
    const workout_payment_form = useSelector(state => state.workout_payment_form);

    return (
        <div className="form">
            <div className="form__scrollable">
                <div className="form__content">
                    <div className="form__header">
                        <i className="form__close" onClick={ () => dispatch(setWorkoutPaymentFormAction(WORKOUT_PAYMENT_FORM_INITIAL)) }/>
                        <div className="form__title">Доплата за тренировку</div>
                    </div>
                    <div className="form__field"/>
                    <Payment
                        payment={ workout_payment_form.payment }
                        totalSum={ workout_payment_form.total_sum }
                        discountValue={ workout_payment_form.discount }
                        handler={ ({ payment, discount, total_sum }) => dispatch(setWorkoutPaymentFormAction({
                            ...workout_payment_form,
                            payment,
                            discount,
                            total_sum
                        })) }
                    />
                    <div className="form__field">
                        <div className="button"
                             onClick={ () => {
                                 let formattedPayments = [];
                                 // Фильтруем и форматируем платежи
                                 workout_payment_form.payment.forEach(el => {
                                     if (el.cost) {
                                         formattedPayments.push({ cost: el.cost, payment_method: el.payment_method.id });
                                     }
                                 });

                                 dispatch(workoutPaymentSagaAction({
                                     workout_id: workout_payment_form.workout_id,
                                     payment: JSON.stringify(formattedPayments),
                                     discount: workout_payment_form.discount.id
                                 }));
                             } }
                        >Сохранить</div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkoutPaymentForm;